(function () {
    'use strict';

    angular.module("imApp").factory("serviceObjectService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1735,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1736,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 2115,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
